<section class="w-full">
  <h2 class="text-2xl font-bold mb-6 text-gray-800">Meine Zähler</h2>

  @if (eigeneZaehler.isLoading()) {
    <div class="flex items-center justify-center py-12">
      <div class="text-center">
        <div class="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto mb-4"></div>
        <p class="text-gray-600">Zähler werden geladen...</p>
      </div>
    </div>
  } @else if (eigeneZaehler.error()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
      <p class="font-medium">Fehler beim Laden der Zähler</p>
      <p class="text-sm mt-1">{{ eigeneZaehler.error()?.message }}</p>
    </div>
  } @else if ((eigeneZaehler.value() || []).length === 0) {
    <div class="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
      <p class="text-gray-700 font-medium">Keine Zähler vorhanden</p>
      <p class="text-sm text-gray-600 mt-2">Sie haben noch keine Zähler registriert.</p>
    </div>
  } @else {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      @for (zaehler of eigeneZaehler.value(); track zaehler?.id) {
        <app-zaehler-component
          [zaehler]="zaehler">
        </app-zaehler-component>
      }
    </div>
  }
</section>
